
import { Visual } from "./visual";

/** test if the interface we have is a Circle */
export function isLine(obj: any): obj is Line {

  return (obj as Line).isLine !== undefined;
}

/**
 *
 * @class Line
 *
 * specifies how to render some part of a canvas object.  The canvas adaptor we are
 * currently using must then render an appropriate object to the actual canvas.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export interface Line extends Visual {

  /** type guard */
  isLine: () => void;

  /** horizontal position */
  x?:               number;

  /** vertical position */
  y?:               number;

  /** horizontal extend */
  width?:           number;

  /** vertical extent */
  height?:          number;

  /** the line segment points*/
  points: {x: number, y: number}[];

  /** the fill color */
  color?: string;

  /** how wide? */
  lineWidth?:     number;

  /** what line ending style? */
  lineCap?: string;

  /** drawn or not */
  visible?:         boolean;

  /** transparency (transparent) 0.0 ... 1.0 (not transparent) */
  opacity?:         number;

}
